'use client';

import { faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import Link from 'next/link';
import { cn } from '~/lib/cn';
import { Icon } from './Icon';
import { LanguageDropdown } from './Language/LanguageDropdown';

export default function Footer({ className }: { className?: string }) {
    return (
        <footer className={cn('tw-container tw-mt-4 tw-px-2 sm:tw-px-0', className)}>
            <div className="tw-container tw-rounded-t-2xl tw-border-0 tw-border-l tw-border-r tw-border-t tw-border-solid tw-border-accents-2 tw-bg-white tw-px-6 tw-pt-6">
                <LanguageDropdown full />
                <div className="tw-grid tw-grid-cols-1 tw-gap-4 tw-py-8 md:tw-grid-cols-4">
                    <div>
                        <Icon color="black" font width={200} className="mb-2" />
                        <small className="tw-mt-3 tw-block">© Copyright {moment().year()}</small>
                        <div className="tw-mt-3">
                            <Link
                                href="https://www.instagram.com/sportisionde/?hl=de"
                                className="tw-link tw-inline-flex tw-items-center tw-gap-2 tw-text-2xl"
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Instagram"
                            >
                                <FontAwesomeIcon icon={faInstagram} />
                            </Link>
                            <Link
                                href="https://www.youtube.com/@johannesvonsportision6701"
                                className="tw-link tw-inline-flex tw-items-center tw-gap-2 tw-text-2xl"
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Youtube"
                            >
                                <FontAwesomeIcon icon={faYoutube} />
                            </Link>
                        </div>
                    </div>
                    <div>
                        <h6 className="tw-mb-2 tw-text-lg tw-font-semibold">Über Sportision</h6>
                        <nav className="tw-flex tw-flex-col tw-gap-2 *:tw-text-success">
                            <Link href="/about" className={'hover:tw-text-success/80'}>
                                Über uns
                            </Link>
                            <Link href="/module" className={'hover:tw-text-success/80'}>
                                Module in der Übersicht
                            </Link>
                            <Link href="/impressum" className={'hover:tw-text-success/80'}>
                                Impressum
                            </Link>
                            <Link href="/agb" className={'hover:tw-text-success/80'}>
                                AGB
                            </Link>
                            <Link href="/datenschutz" className={'hover:tw-text-success/80'}>
                                Datenschutzrichtlinien
                            </Link>
                        </nav>
                    </div>
                    <div>
                        <h6 className="tw-mb-2 tw-text-lg tw-font-semibold">Unsere Funktionen</h6>
                        <nav className="tw-flex tw-flex-col tw-gap-2 *:tw-text-success">
                            <Link href="/online-anmeldungen" className={'hover:tw-text-success/80'}>
                                Online-Anmeldungen
                            </Link>
                            <Link href="/trainingsplanerstellung" className={'hover:tw-text-success/80'}>
                                Trainingsplanerstellung
                            </Link>
                            <Link href="/trainingsjournal" className={'hover:tw-text-success/80'}>
                                Trainingsjournal
                            </Link>
                            <Link href="/trainerstunden" className={'hover:tw-text-success/80'}>
                                Trainerstunden
                            </Link>
                            <Link href="/rechnungen" className={'hover:tw-text-success/80'}>
                                Abrechnung & Buchhaltung
                            </Link>
                            <Link href="/platzbuchungen" className={'hover:tw-text-success/80'}>
                                Platzbuchungen
                            </Link>
                            <Link href="/mitgliederverwaltung" className={'hover:tw-text-success/80'}>
                                Mitgliederverwaltung
                            </Link>
                            <Link href="/vereinskommunikation" className={'hover:tw-text-success/80'}>
                                Vereinskommunikation
                            </Link>
                            {/* <Link href="/app" className={'hover:tw-text-success/80'}>
                                App
                            </Link> */}
                        </nav>
                    </div>
                    <div>
                        <h6 className="tw-mb-2 tw-text-lg tw-font-semibold">Support</h6>
                        <nav className="tw-flex tw-flex-col tw-gap-2 *:tw-text-success">
                            <Link href="/kontakt" className={'hover:tw-text-success/80'}>
                                Kontakt Sportision
                            </Link>
                            <Link href="/academy" className={'hover:tw-text-success/80'}>
                                Sportision Academy
                            </Link>
                        </nav>
                    </div>
                </div>
            </div>
        </footer>
    );
}
